import { render, staticRenderFns } from "./SegmentFilter.vue?vue&type=template&id=ffdb50a2&scoped=true"
import script from "./SegmentFilter.vue?vue&type=script&lang=js"
export * from "./SegmentFilter.vue?vue&type=script&lang=js"
import style0 from "./SegmentFilter.vue?vue&type=style&index=0&id=ffdb50a2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdb50a2",
  null
  
)

export default component.exports